<template>
  <v-container>
    <v-row>
      <!-- Información básica del grupo -->
      <v-col cols="12" class="pb-1">
        <v-card class="elevation-0 transparent">
          <v-card-text>
            <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Tickets
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <v-spacer></v-spacer>
            <v-btn 
              color="orange" 
              tile 
              small 
              class="mr-2"
              dark
              @click="dialogAddTicket = true"
            >
              <v-icon small left>mdi-plus</v-icon>
              Agregar
            </v-btn>
            <v-btn 
              color="primary" 
              tile 
              small 
              @click="initialize()"
            >
              <v-icon small left>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>
          <v-data-table
            width="100%"
            :headers="headers"
            :items="tickets"
            class="elevation-0"
            :page.sync="page"
            @page-count="pageCount = $event"
            :mobile-breakpoint="100"
            hide-default-footer
          >
            <template v-slot:item.estatus="{ item }">
              <v-chip small color="blue"   dark v-if="item.estatus == 1"> Pendiente  </v-chip>
              <v-chip small color="blue"   dark v-if="item.estatus == 2"> Pendiente  </v-chip>
              <v-chip small color="blue"   dark v-if="item.estatus == 3"> Pendiente  </v-chip>
              <v-chip small color="blue"   dark v-if="item.estatus == 4"> Pendiente  </v-chip>
              <v-chip small color="green"  dark v-if="item.estatus == 5"> Respondido </v-chip>
              <v-chip small color="yellow"      v-if="item.estatus == 6"> Cerrado    </v-chip>
              <v-chip small color="black"  dark v-if="item.estatus == 7"> Rechazado  </v-chip>
            </template>


            <template v-slot:item.ver="{ item }">
              <v-chip small color="grey" dark @click="ver( item )"> Ver </v-chip>
            </template>

          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogVer"
      max-width="600px"
    >
      <v-card>

        <!-- Titulo -->
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <!-- Cuarpo -->
        <v-card-text v-for="(respuesta, i) in historial" :key="i" >
          <!-- Historial -->
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0">
                <div>{{ respuesta.fecha }}</div><br/>
                <v-textarea rows="3" auto-grow outlined v-model="respuesta.motivo" label="Motivo de tu ticket" readonly></v-textarea>
                <v-textarea rows="3" auto-grow outlined v-model="respuesta.respuesta" label="Solución" readonly></v-textarea>
                <v-textarea rows="3" auto-grow outlined v-model="respuestaRechazo" height="auto" label="Motivo de rechazo" hide-details 
                  v-if="rechazar && i == ( historial.length - 1 )">                 
                </v-textarea>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col cols="12" md="4" v-for="(img, i) in evidencias" :key="i">
                <v-card class="py-4 shadowCard" @click="verImagen( img.foto )">
                  <v-img :src="url + img.foto" contain aspect-ratio="2"></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions v-if="respuesta.estatus == 0 && ticket.estatus == 5">
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              dark
              small
              tile
              v-if="rechazar == false"
              @click="rechazar=true"
            >
              Rechazar
            </v-btn>

            <v-btn
              color="dark"
              dark
              small
              tile
              v-if="rechazar == true"
              @click="rechazar = false"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="success darken-1"
              tile
              small
              @click="cerrarTicket()"
              v-if="!rechazar"
            >
              Cerrar
            </v-btn>

            <v-btn
              v-else
              tile
              dark
              small
              color="blue darken-1"
              @click="rechazarTicket( )"
            >
              Enviar
            </v-btn>
          </v-card-actions>

          <v-card-actions v-else-if="i == ( historial.length - 1)">
            <v-spacer></v-spacer>
            <v-btn
              color="black"
              dark
              rounded
              small
              @click="dialogVer = false, historial = []"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAddTicket"
      max-width="600px"
    >
      <v-card>
        <v-card-title primary-title>
          Agregar Ticket
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="motivo"
            label="Detalla tu problema"
            filled
            :rows="3"
            auto-grow
          ></v-textarea>

          <v-col cols="12">
            <v-file-input
              small-chips
              multiple
              filled
              v-model="files"
              accept="image/png, image/jpeg, image/bmp"
              placeholder="Selecciona tus imagenes"
              prepend-icon="mdi-camera"
              label="Imágenes"
              @change="cargarFotos()"
            ></v-file-input>
          </v-col>
  
          <v-alert
            text
            dense
            color="teal"
            icon="mdi-information"
            border="left"
          >
            Por favor, detalla tu problema para que se le pueda dar una solución más rápida, también, escribe que es lo que te gustaría obtener como respuesta.
          </v-alert>

          <v-row>
            <v-col cols="12" md="6"v-for="(img, i) in vistaPrevias" :key="i">
              <v-card class="py-4 shadowCard">
                <v-img :src="img.url" contain aspect-ratio="2"></v-img>
                <v-btn 
                  color="error" 
                  small 
                  @click="eliminarFoto(img.url)"
                  top
                  right
                  absolute
                  fab
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-btn 
            color="black" 
            small
            tile
            dark
            @click.stop="dialogAddTicket = false"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="green" 
            tile
            dark
            small
            :loading="disabled"
            :disabled="disabled" 
            @click.stop="addTicket()"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Visualizar imagenes -->
    <v-dialog
      v-model="dialogImagen"
      max-width="600px"
    >
      <v-card class="elevation-0">
        <v-card-text>
          <!-- Imagen -->
          <v-col cols="12">
            <v-img
              :src="url + imagen"
              contain
              max-width="600"
              height="750"
            >
            </v-img>
          </v-col>
        </v-card-text>
        <!-- Guardar la información  -->
        <v-btn
          absolute
          right
          top
          color="grey"
          dark
          fab
          class="elevation-6 mt-8"
          @click="dialogImagen = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn
        >
      </v-card>
    </v-dialog>

    <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader    v-if="cargar"          :loader="loader"/>

  </v-container>
</template>
<script>
  // importar librerías
  import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');

  // Componentes
  import Alerta        from '@/components/alertas/Alerta.vue'
  import Loader        from '@/components/alertas/Loader.vue'

  export default {
    name: "dashboard-default",
    data: () => ({
      headers:[
        { text: 'Folio'     , value: 'idticket'    , class: 'text-uppercase grey--text text-caption', width: '10' },
        { text: 'Fecha'     , value: 'fecha_corta' , class: 'text-uppercase grey--text text-caption text-center', align: 'center' },
        { text: 'Estatus'   , value: 'estatus'     , class: 'text-uppercase grey--text text-caption text-center', align: 'center' },
        { text: 'Ver'       , value: 'ver'         , class: 'text-uppercase grey--text text-caption text-center', align: 'center' },
      ],
      url: '',
      show: false,
      respuestaAlerta: false,

      loader: true,
      cargar: false,
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      tickets:[],

      disabled: false,
      loading: false,

      historial:[],
      dialogVer: false,

      rechazar: false,
      ticket:null,
      respuestaRechazo:'',

      dialogAddTicket: false,
      motivo:'',
      id_suc:0,

      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      fotos:[],
      files: [],
      vistaPrevias:[],

      dialogImagen:false,
      imagen: '',
      evidencias:[],
    }),

    components: {
      Alerta
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso', 'getGrupos' ]),

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar ticket' : 'Ver Ticket'
      },
    },

    created(){
      
      if(this.getGrupos.length){
        this.id_suc = this.getGrupos[0].id_plantel
      }
      this.url = this.$http.options.root + 'evidencia-tickets/'
      this.initialize () 

    },


    methods:{
      ...mapActions( 'login', [ 'abrirRecursosAlumno', 'abrirVentanaRecurso'] ),

      initialize ( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.iderp )

        this.tickets = []

        const ruta = this.getUsuarioLMS.roll == 'TEACHER' ?  `tickets.get.usuario.erp/` : `tickets.alumnos/`

        this.$http.get( ruta + id_usuario ).then(response => { 
          // Aqui las ponemos
          this.tickets = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },
      
      ver ( item ) {
        this.historial = item.historial
        this.evidencias = item.evidencias
        this.ticket    = item
        this.dialogVer = true
      },

      cerrarTicket () {
        const idticket = base64.encode( this.ticket.idticket )

        this.$http.put('tickets.cerrar/'+ idticket ).then(response=>{
          this.dialogVer = false
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      rechazarTicket ( ){
        const payload = {
          idticket:      this.ticket.idticket,
          respuesta:     '',
          motivo:        this.respuestaRechazo,
          respuestaauxi: '',
        }
        return this.$http.post('tickets.rechazar', payload).then(response=>{
          this.dialogVer = false
          this.historial = []
          this.mensaje   = ''
          this.respuestaRechazo = ''
          this.ticket   = null
          this.rechazar = false
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      async addTicket ( ){


        if( this.motivo != ''){
          
          let fotos = []
          if(this.vistaPrevias.length){
            let respuesta = await this.subirFotosServidor( )
            fotos = respuesta.body
          }

          this.disabled = true
          
          const payload = {
            motivo:            this.motivo,
            estatus:           1,
            id_usuario:        this.getUsuarioLMS.iderp,
            tipousuario:       this.getUsuarioLMS.roll == 'TEACHER' ? 0 : 1,
            id_suc:            this.id_suc,
            fotos
          };

          this.$http.post("tickets.agregar", payload).then((response) => {
            this.disabled = false
            this.motivo = ''
            this.dialogAddTicket = false
            this.initialize()
          }).catch( error =>{
            this.disabled = false
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }else{
          this.disabled = false
          this.parametros.mensaje      = 'Ingresa el motivo para avanzar'
          this.parametros.color        = '#FF2C2C' 
          this.parametros.dialogError  = true 
          this.respuestaAlerta = true 
        }
      },

      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      verImagen( imagen ){
        this.imagen       = imagen
        this.dialogImagen = true
      },

      subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
          // obtener la extensión del archivo
          // Hacemos la petición
          this.$http.post(`tickets.subir.evidencia`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        })
      },

      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
          //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          this.getBase64(element, formData)
        })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          me.vistaPrevias.push({
            url: reader.result, 
            formData: formData, 
            image_name: file.name,
            file
          })
        };
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },

    }
  };
</script>

<style scoped>
  .shadowCard{
    border-radius: 15px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.15)  !important;
  }
  
  .colorCurso{
    color: #006093;
  }
         
</style>
